// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { type ReactElement } from "react";

import { FormattedMessage } from "react-intl";

export const LensFolderNotFound = (): ReactElement => (
    <FormattedMessage
        id="apps.lenses.components.noLensFolders.lensFolderNotFound"
        description="Lens folder not found."
        defaultMessage="Lens Folder Not Found"
    />
);
LensFolderNotFound.displayName = "LensFolderNotFound";

export const NoLensFolders = (): ReactElement => (
    <FormattedMessage
        id="apps.lenses.components.noLensFolders.noLensFolders"
        description="No lens folders."
        defaultMessage="No Lens Folders"
    />
);
NoLensFolders.displayName = "NoLensFolders";

export const LensFolderNotFoundContent = (): ReactElement => (
    <FormattedMessage
        id="apps.lenses.components.noLensFolders.lensFolderNotFoundContent"
        description="Lens folder not found content."
        defaultMessage="No lens folder with that name was found."
    />
);
LensFolderNotFoundContent.displayName = "LensFolderNotFoundContent";

export const NoLensFoldersContent = (): ReactElement => (
    <FormattedMessage
        id="apps.lenses.components.noLensFolders.noLensFoldersContent"
        description="No lens folders content."
        defaultMessage="This organization has no lens folders. Create a folder to get started, or select a different organization from the dropdown menu above."
    />
);
NoLensFoldersContent.displayName = "NoLensFoldersContent";
